module.exports = __webpack_public_path__ + "img/side-image01 1.d38a273d.png";